<template>
  <div class="p-config-keywords">
    <div v-if="data.items.length" class="l-mb-6">
      <h2 class="hTitle">設定中の検索順位キーワード</h2>
      <table class="c-table edit">
        <thead>
          <tr>
            <td>キーワード</td>
            <td>登録URL</td>
            <td width="69">削除</td>
          </tr>
        </thead>
        <tbody>
          <FormEditSeedKeywords
            v-for="(item, index) in data.items"
            :key="item.id"
            :index="index"
            :item="item"
            :project="project"
            :isLoading="isLoading"
            @delete="deleteKeyword"
            @update="updateKeyword"
          />
        </tbody>
      </table>
    </div>
    <h2 class="hTitle">検索順位キーワードの登録</h2>
    <FormAddSeedKeyword
      :items="data.items"
      :project="project"
      :isLoading="isLoading"
      @add="addKeywords"
    />
  </div>
</template>
<script>
import FormEditSeedKeywords from '@/components/config/FormEditSeedKeywords';
import FormAddSeedKeyword from '@/components/config/FormAddSeedKeyword';
import apiProjects from '@/api/projects';

export default {
  props: ['project'],
  components: {
    FormAddSeedKeyword,
    FormEditSeedKeywords
  },
  data() {
    return {
      data: {
        items: []
      },
      isLoading: true
    };
  },
  created() {
    this.getKeywords();
  },
  methods: {
    addKeywords(items) {
      this.data.items = this.data.items.concat(items);
    },
    deleteKeyword(index) {
      this.data.items.splice(index, 1);
    },
    updateKeyword(item, index) {
      this.data.items.splice(index, 1, item);
    },
    getKeywords() {
      this.isLoading = true;

      apiProjects.observationKeywords
        .get(this.auth.idToken, this.project.id)
        .then(response => {
          this.data.items = response.data.items;
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
        });
    }
  }
};
</script>
